import React from 'react';
import { Box, ListItemIcon, ListItemText, Typography, Badge } from '@mui/material';
import { MenuContentProps } from '../../types';

const Icon: React.FC<{ icon: string; size?: number }> = ({ icon, size = 16 }) => (
    <i className={icon} style={{ fontSize: size, color: 'inherit', width: size, textAlign: 'center', lineHeight: 1 }} />
);

const MenuContent: React.FC<MenuContentProps> = ({ item, isCollapsed, level, isHorizontal = false }) => {
    const showCollapsedIcon = isCollapsed && level === 0 && !isHorizontal;
    const displayIcon = item.icon;

    if (showCollapsedIcon) {
        return displayIcon ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <ListItemIcon sx={{ minWidth: 'unset', justifyContent: 'center' }}>
                    <Icon icon={displayIcon} size={18} />
                </ListItemIcon>
            </Box>
        ) : null;
    }

    return (
        <>
            {displayIcon && (
                <ListItemIcon sx={{ minWidth: isHorizontal ? 'unset' : undefined, color: 'inherit' }}>
                    {item.badge && item.badge > 0 ? (
                        <Badge 
                            badgeContent={item.badge} 
                            color="error"
                            max={99}
                            sx={{
                                '& .MuiBadge-badge': {
                                    fontSize: '0.65rem',
                                    height: '18px',
                                    minWidth: '18px',
                                    padding: '0 4px',
                                }
                            }}
                        >
                            <Icon icon={displayIcon} />
                        </Badge>
                    ) : (
                        <Icon icon={displayIcon} />
                    )}
                </ListItemIcon>
            )}
            <ListItemText 
                primary={
                    <Typography variant="body2" sx={{ color: 'inherit', ...(isHorizontal && { fontSize: 15, fontWeight: 500, whiteSpace: 'nowrap' }) }}>
                        {item.label}
                    </Typography>
                } 
                sx={isHorizontal ? { m: 0 } : undefined}
            />
        </>
    );
};

export default MenuContent;
